/** Nombre accesible de la región y título visible del bloque. */
export const SECTION_LABEL = 'Vistos recientemente'

/** Id del panel colapsable, referenciado por `aria-controls` del trigger. */
export const PANEL_ID = 'recently-viewed-panel'

/** Tamaño del icono del botón de quitar (el área activable se amplía por CSS). */
export const REMOVE_ICON_SIZE = 14

/** Nombre accesible del botón de quitar: identifica de qué evento se trata,
 * porque un icono sin nombre no distingue una tarjeta de otra (FR-026). */
export function removeLabel(title: string): string {
  return `Quitar "${title}" de ${SECTION_LABEL.toLowerCase()}`
}

/** Mensaje de la región `status` al quitar un evento: sin él, quien use lector
 * de pantalla no percibe que la tarjeta ha desaparecido. */
export function removedAnnouncement(title: string): string {
  return `"${title}" quitado de ${SECTION_LABEL.toLowerCase()}`
}

/** Mensaje de la región `status` al limpiar todo el historial. */
export const CLEARED_ANNOUNCEMENT = 'Historial de vistos recientemente vacío'

/** Etiqueta compacta de la acción de limpiar (móvil/tablet). */
export const CLEAR_SHORT_LABEL = 'Limpiar'

/** Etiqueta completa de la acción de limpiar (escritorio). */
export const CLEAR_ALL_LABEL = 'Limpiar todo'

/** Tamaño del chevron del control de plegado. */
export const CHEVRON_ICON_SIZE = 20

/** Nombre accesible del overlay de carga mientras se pide el lote de eventos. */
export const LOADING_LABEL = 'Cargando vistos recientemente'

/** Cuánto se mantiene el overlay de carga tras llegar los datos, en páginas
 * que abren el carril por defecto (`defaultOpen`): cubre la microanimación de
 * apertura del panel (`panelRevealing` en el SCSS, `--motion-slow`) para que
 * el visitante nunca vea el carril a medio desplegar. Duración fija en vez de
 * escuchar `animationend`/`transitionend`: con `prefers-reduced-motion` la
 * animación no se reproduce y ese evento nunca llegaría a disparar, dejando
 * el overlay varado para siempre. */
export const REVEAL_HOLD_MS = 320
